import { API_CENTRE } from "./config";
import { apiCallWithAuth } from "../helper/apiManager";

export default class AuthorizationService {
  static async getAuthorizationUser(resourceKey: string) {
    try {
      const { data } = await apiCallWithAuth(
        API_CENTRE +
          "/api/v1/authmanager/authorize?resourceKey=" +
          resourceKey,
        "get",
      );

      return data;
    } catch (err) {
      return null;
    }
  }

  static async getMyFrontResources() {
    try {
      const { data } = await apiCallWithAuth(
        API_CENTRE + "/api/v1/authmanager/myfrontresources",
        "get",
      );
      return data;
    } catch (err) {
      return null;
    }
  }
}
